import { SponsoredCard } from "./sponsored-card.model";

export class SponsoredCardTranslation{
    constructor( 
        public id?:  number,
        public title?: string,
        public detail?: string,
        public distance?: string,
        public minPrice?: number,
        public maxPrice?: number,
        public currency?: string, 
        public locale?: string,
        public sponsoredCard?: SponsoredCard
    ){}
}